var _path, _path2, _path3, _path4, _path5, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _rect, _circle7, _g, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHobbyDevelopment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 255,
    height: 149,
    viewBox: "0 0 255 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96 132C71.6995 132 52 112.301 52 88C52 63.6995 71.6995 44 96 44C120.301 44 140 63.6995 140 88C140 112.301 120.301 132 96 132Z",
    fill: "#1D2648"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M130 149C105.699 149 86 129.301 86 105C86 80.6995 105.699 61 130 61C154.301 61 174 80.6995 174 105C174 129.301 154.301 149 130 149Z",
    fill: "#1D2648"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M142 96C115.49 96 94 74.5097 94 48C94 21.4903 115.49 0 142 0C168.51 0 190 21.4903 190 48C190 74.5097 168.51 96 142 96Z",
    fill: "#1D2648"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M159 132C132.49 132 111 110.51 111 84C111 57.4903 132.49 36 159 36C185.51 36 207 57.4903 207 84C207 110.51 185.51 132 159 132Z",
    fill: "#1D2648"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M98 90C73.6995 90 54 70.3005 54 46C54 21.6995 73.6995 2 98 2C122.301 2 142 21.6995 142 46C142 70.3005 122.301 90 98 90Z",
    fill: "#1D2648"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    transform: "matrix(-1 0 0 1 248 52)",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(-1 0 0 1 39 135)",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-1 0 0 1 3 52)",
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-1 0 0 1 47 1)",
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-1 0 0 1 200 0)",
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-1 0 0 1 218 136)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11322_9756)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 19,
    width: 104,
    height: 104,
    rx: 52,
    fill: "#CEE446"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11322_9756",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 76,
    y: 19,
    width: 104,
    height: 104
  }, _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 71,
    r: 52,
    fill: "#CCCCCC"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11322_9756)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.744 150.667C97.1292 169.282 66.9483 169.282 48.3333 150.667C29.7183 132.052 29.7183 101.871 48.3333 83.2559C66.9483 64.6409 97.1292 64.6409 115.744 83.2559C134.359 101.871 134.359 132.052 115.744 150.667Z",
    fill: "#F7F9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.667 58.7393C189.052 77.3543 158.872 77.3543 140.257 58.7393C121.642 40.1243 121.642 9.94342 140.257 -8.67157C158.872 -27.2866 189.052 -27.2866 207.667 -8.67157C226.282 9.94342 226.282 40.1243 207.667 58.7393Z",
    fill: "#F7F9ED"
  })))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 13.5L31 20",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M230.5 98.5L253 102.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M205.5 32L226.5 23.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 106.5L20.5 111",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11322_9756"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 19,
    width: 104,
    height: 104,
    rx: 52,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHobbyDevelopment);
export default __webpack_public_path__ + "static/media/hobby-development.41165945b2b3138971204983af07c1b0.svg";
export { ForwardRef as ReactComponent };